import { ImageGalleryItem } from './screen-item';

export default ImageGalleryItem;
